import React, { Component, Fragment } from "react";
import FireAssuranceContext from "./FireAssuranceContext";
import WidgetSummary from "../../components/WidgetSummary";
import { Accordion, Card } from "react-bootstrap";
import UserIcon from "../../images/user_icon.svg";
import ChevonDown from "../../images/chevron-down.svg";
import Edit from "../../images/edit.svg";
import BenefitBlock from "../../components/BenefitBlock";
import CheckBoxInsuranceConfirm from "../../components/CheckBoxInsuranceConfirm";
import { CurrencyUtils } from "../../utils";
import { DATETHAI_FORMAT, DATE_FORMAT, BANK_DEFAULT_SELECT } from "../../const";
import CheckBoxReceived from '../../components/CheckBoxReceived';
import moment from "moment";


const imgScale = {
  width: "24px",
  height: "24px"
};
const Icon = props => (
  <img className={props.className} src={props.src} {...imgScale} />
);

class FireAssuranceStep3 extends Component {
  callBackAction;
  constructor(props) {
    super(props);
  }

  render() {
    const { step1, step2, step3 } = this.context;
    const { planList } = step1;
    const {
      recieveEmail,
      recievePost,
      confirmInsurance,
      onChangeModel,
      onNavigate
    } = step3;
    const {
      isOtherAddress,
      sNationality,
      sIDNo = "",
      sSex,
      sInitNameTH = "",
      sFirstNameTH = "",
      sLastNameTH = "",
      sBirthDate = "",
      sOccupation = "",
      sMobile = "",
      sEmail = "",
      sStart_date = "",
      sEnd_date = ""
    } = step2;
    const {
      sNo = "",
      sMoo = "",
      sSoi = "",
      sRoad = "",
      sProvince = "",
      sDistrict = "",
      sCity = "",
      sZipcode = ""
    } = step2;
    const {
      sNoOther = "",
      sMooOther = "",
      sSoiOther = "",
      sRoadOther = "",
      sProvinceOther = "",
      sDistrictOther = "",
      sCityOther = "",
      sZipcodeOther = ""
    } = step2;
    const {
      benefits,
      benefitType,
      legalBenefit,
      bankBenefit,
      companyBenefit
    } = step2;
    const no = sNo ? `เลขที่ ${sNo} ` : ``;
    const moo = sMoo ? `หมู่ ${sMoo} ` : ``;
    const soi = sSoi ? `ซอย ${sSoi} ` : ``;
    const road = sRoad ? `ถนน${sRoad} ` : ``;
    const subDistrict = sDistrict ? `แขวง${sDistrict.label} ` : ``;
    const district = sCity ? `เขต${sCity.label} ` : ``;
    const province = sProvince ? `${sProvince.label} ` : ``;
    const zipcode = sZipcode ? `${sZipcode} ` : ``;
    const address = `${no}${moo}${soi}${road}${subDistrict}${district}${province}${zipcode}`;
    // Property address
    const noOther = sNoOther ? `เลขที่ ${sNoOther} ` : ``;
    const mooOther = sMooOther ? `หมู่ ${sMooOther} ` : ``;
    const soiOther = sSoiOther ? `ซอย ${sSoiOther} ` : ``;
    const roadOther = sRoadOther ? `ถนน${sRoadOther} ` : ``;
    const subDistrictOther = sDistrictOther
      ? `แขวง${sDistrictOther.label} `
      : ``;
    const districtOther = sCityOther ? `เขต${sCityOther.label} ` : ``;
    const provinceOther = sProvinceOther ? `${sProvinceOther.label} ` : ``;
    const zipcodeOther = sZipcodeOther ? `${sZipcodeOther} ` : ``;
    const propertyAddress = `${noOther}${mooOther}${soiOther}${roadOther}${subDistrictOther}${districtOther}${provinceOther}${zipcodeOther}`;
    const planDetail = planList[0];
    const diffDate = sBirthDate
      ? moment.utc().diff(moment(sBirthDate), "years")
      : "-";
    return (
      <Fragment>
        <div className="form-wrapper info">
          <div className="form-group">
            <label>ทุนประกัน</label>
            <label className="value">
              {CurrencyUtils.currency(planList[0].insured)} บาท
            </label>
          </div>
          <div className="form-group">
            <label>ระยะเวลาเอาประกัน</label>
            <label className="value">
              {moment(sStart_date).format(DATETHAI_FORMAT)} -{" "}
              {moment(sEnd_date).format(DATETHAI_FORMAT)}
            </label>
          </div>
          <div className="form-group">
            <label>ลักษะสิ่งปลูกสร้าง</label>
            <label className="value">บ้านเดี่ยว</label>
          </div>
          <div className="summary-reactagle">
            <div className="form-group">
              <label>รายการเบี้ยประกันรวม</label>
              <label className="totalPrice">
                {CurrencyUtils.currency(planList[0].total)} บาท
              </label>
              <label className="help">
                (เบี้ยประกันภัยรวมภาษีและอากรแสตมป์แล้ว)
              </label>

              <WidgetSummary planDetail={planDetail} />
            </div>
          </div>
          <div className="form-group">
            <Accordion defaultActiveKey={"0"} className="accordion-wrapper">
              <Card className="accordion-item" key={"0"}>
                <div className="d-flex align-item-center ml-3">
                  <Icon src={UserIcon} />
                  <p className="header-accordion-text">ข้อมูลผู้เอาประกัน</p>
                  <div className="ml-auto mr-3" onClick={() => onNavigate(2)}>
                    <Icon src={Edit} />
                  </div>
                  <Accordion.Toggle
                    className="pl-0"
                    as={Card.Header}
                    eventKey={"0"}
                  >
                    <Icon src={ChevonDown} />
                  </Accordion.Toggle>
                </div>
                <Accordion.Collapse eventKey={"0"}>
                  <Card.Body className="accordion-body">
                    <div className="form-group">
                      <label>บัตรประชาชน</label>
                      <p>{sIDNo}</p>
                    </div>
                    <div className="form-group">
                      <label>ชื่อ-สกุล (ภาษาไทย)</label>
                      <p>
                        {sFirstNameTH} {sLastNameTH}
                      </p>
                    </div>
                    <div className="form-group">
                      <label>วันเกิด</label>
                      <p>
                        {moment(sBirthDate)
                          .locale("th")
                          .format(DATE_FORMAT)}
                      </p>
                    </div>
                    <div className="form-group">
                      <label>อายุ</label>
                      <p>{diffDate} ปี</p>
                    </div>
                    <div className="form-group">
                      <label>อาชีพ</label>
                      <p>{sOccupation.label}</p>
                    </div>
                    <div className="form-group">
                      <label>เบอร์โทรศัพท์</label>
                      <p>{sMobile}</p>
                    </div>
                    <div className="form-group">
                      <label>อีเมล</label>
                      <p>{sEmail}</p>
                    </div>
                    <hr />
                    <div className="form-group">
                      <label>สถานที่ตั้งทรัพย์สินที่เอาประกันภัย</label>
                      <p>{propertyAddress}</p>
                    </div>
                    <div className="form-group">
                      <label>ที่อยู่ผู้เอาประกันและจัดส่งกรมธรรม์</label>
                      <p>{ isOtherAddress === 1 ? propertyAddress : address}</p>
                    </div>
                    {/* Benefit Section */}
                    <div className="form-group">
                      {benefitType.label === "บุคคลธรรมดา" ? (
                        <Fragment>
                          {benefits.map((benefit, index) => {
                            return benefit ? (
                              <BenefitBlock
                                key={index}
                                index={index}
                                benefit={benefit}
                              />
                            ) : (
                              ""
                            );
                          })}
                        </Fragment>
                      ) : benefitType.label === "นิติบุคคล" ? (
                        <Fragment>
                          <label>ผู้รับผลประโยชน์</label>
                          <label>นิติบุคคล</label>
                          <p>{legalBenefit}</p>
                        </Fragment>
                      ) : benefitType.label === "สถาบันการเงิน" &&
                        (
                        <Fragment>
                          <label>ผู้รับผลประโยชน์</label>
                          <label>สถาบันการเงิน</label>
                          <p>{bankBenefit && bankBenefit.value === "000" ? companyBenefit : bankBenefit.label}</p>
                        </Fragment>
                      )}
                    </div>

                    <hr />
                    <div className="form-group">
                      <label>อีเมลสำหรับข้อมูลกรมธรรม์</label>
                      <p>{sEmail}</p>
                    </div>
                    <div className="form-group">
                      <label>เบอร์ติดต่อ</label>
                      <p>{sMobile}</p>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
            <CheckBoxReceived 
              recieveEmail={recieveEmail}
              recievePost={recievePost}
              onChangeModel={onChangeModel}
            />
          </div>
        </div>
        <div className="form-wrapper">
          <CheckBoxInsuranceConfirm
            checked={confirmInsurance}
            onCheckChange={checked =>
              onChangeModel({ name: "confirmInsurance", value: checked })
            }
          />
        </div>
      </Fragment>
    );
  }
}

FireAssuranceStep3.contextType = FireAssuranceContext;
export default FireAssuranceStep3;
